import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import queryString from 'query-string';

// Contexts
import { withTenant, withTranslate } from "../../core/TenantProvider";
// Components - Atoms
import APLoadingSpinner from '../../components/atoms/APLoadingSpinner';
// Redux
import { ReducerState } from '../../redux/modules';
import { actions as UserActions } from '../../redux/modules/user';
import { actions as servicesDowntimeAction } from '../../redux/modules/servicesDowntime';
// Types
import { RoleAccessFunction } from '../../core/types/AffiliateDetails';

interface TokenValidationContainerProps {
    validateToken: Function;
    isAuthenticated: boolean;
    affiliateDetails: any;
    roleAccessFunction: RoleAccessFunction;
    getServicesErrorObj: Function;
}

const TokenValidationContainer = (props: TokenValidationContainerProps) => {
    const {
        validateToken,
        isAuthenticated,
        affiliateDetails,
        roleAccessFunction,
        getServicesErrorObj
    } = props;

    const [hasError, setHasError] = useState<boolean>(false);
    const hasValidated = useRef<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();

    const queryParam: queryString.ParsedQuery<string> = queryString.parse(location.search);
    const { token, email, affiliateNumber, accountSfId } = queryParam;

    const { VIEW_ACCOUNT } = roleAccessFunction;

    useEffect(() => {
        if (isAuthenticated && affiliateDetails) {
            if (typeof VIEW_ACCOUNT === 'boolean') {
                navigate(VIEW_ACCOUNT ? '/account' : '/client_management');
            } else {
                navigate('/account');
            }
        }
    }, [isAuthenticated, affiliateDetails, navigate, VIEW_ACCOUNT]);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout | null = null;

        if (isAuthenticated || hasValidated.current) {
            return;
        }

        if (!token || !email || !affiliateNumber || !accountSfId) {
            setHasError(true);
            timeoutId = setTimeout(() => {
                navigate('/login');
            }, 1000);
            return () => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            };
        }

        hasValidated.current = true;

        validateToken(token as string, email as string, affiliateNumber as string, accountSfId as string)
            .catch((error: any) => {
                setHasError(true);
                getServicesErrorObj(error);
                timeoutId = setTimeout(() => {
                    navigate('/login');
                }, 1000);
            });

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [isAuthenticated]);


    if (hasError) {
        return null;
    }

    return <APLoadingSpinner />;
}

const mapStateToProps = (store: ReducerState) => ({
    isAuthenticated: store.user.isAuthenticated,
    affiliateDetails: store.user.affiliateDetails,
    roleAccessFunction: store.user.roleAccessFunction
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    validateToken: UserActions.validateToken,
    getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withTenant(
        withTranslate(
            TokenValidationContainer
        )
    )
);
